"use strict"

class CustomFullPagejs {
    constructor() {
        this.isMobile = false;
        this.isDesktop = false;
        this.mobileToDesktop = false;
        this.desktopToMobile = false;
        this.breakpoint = 790;
        this.noResize = true;
        this.header = document.querySelector('#header nav');
    }
    renderMethodOnLoad() {
        window.innerWidth < this.breakpoint ? this.mobileMethod() : this.desktopMethod()
        window.innerWidth < this.breakpoint ? this.isMobile = true : this.isDesktop = true;
    }
    renderMethodOnResize() {
        window.onresize = () => {
            if (window.innerWidth < this.breakpoint) {
                this.isDesktop = true;
                if (this.isMobile) this.mobileMethod()
                this.isMobile = false;
                this.desktopToMobile = true
            } else {
                this.isMobile = true;
                if (this.isDesktop) this.desktopMethod()
                this.isDesktop = false;
                this.mobileToDesktop = true;
            }
        };
    }
    // hides header except social links after the first slide only on desktop
    hideHeader(des) {
        let headerChildren = this.header.children;

        for (let i = 0 ; i < headerChildren.length ; i++) {
            headerChildren[i].style.visibility = (des.index !== 0) ? "hidden" : "visible";
        }
    }
    instance() {
        let anchors = [];
        if (this.isMobile) {
            anchors = ['home', 'skills', 'partners', 'map', 'clients', 'stats', 'news'];

        } else {
            anchors = ['home', 'skills', 'partners', 'clients', 'stats', 'news'];
        }

        new fullpage('#fullpage', {
            navigation: true,
            showActiveTooltip: true,
            slidesNavigation: true,
            // set overflow: scroll to partenrs resp text content
            normalScrollElements: '.partners-slick .slick-active p',
            sectionSelector: '.fullpage-section',
            licenseKey: 'B8569985-819548DA-AAA7D92F-027B0B11',
            anchors: anchors,
            onLeave: (org, des) => this.hideHeader(des)
        })
    }

    mobileMethod() {
        this.instance()
    }
    desktopMethod() {
        this.instance()
    }
    renderFullpage() {
        if (!document.querySelector(".nofullpage")) {
            this.renderMethodOnLoad()
            if (this.noResize) this.renderMethodOnResize()
        }
    }
}

export default CustomFullPagejs;


// WEBPACK FOOTER //
// ./src/scripts/components/CustomFullPagejs.js